/**
 * CitationBadge — inline [N] citation marker with hover tooltip.
 * Renders as a small cyan superscript number that shows the source on hover.
 */
import { useState } from 'react';

interface Props {
  index: number;
  label: string;
}

export function CitationBadge({ index, label }: Props) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span className="relative inline-block">
      <sup
        className="inline-flex items-center justify-center min-w-[14px] h-[14px] px-0.5 text-[9px] font-medium text-cyan-400 bg-cyan-500/15 rounded cursor-help hover:bg-cyan-500/25 transition-colors"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {index}
      </sup>
      {showTooltip && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 text-[10px] text-mono-200 bg-mono-800 border border-mono-700/50 rounded shadow-lg whitespace-nowrap z-50">
          {label}
        </span>
      )}
    </span>
  );
}
